import type { FieldValue, FieldValues, StepConfig, StepFormField } from '../../types/workflow';

const sendMessage: StepConfig = {
  // Design
  icon: 'sendMessage',
  headerTextColor: '#095EA6',
  headerColor: '#CBEEFA',
  title: 'Send Message',
  text: 'Message .....',
  service: 'bbc',
  category: 'Node',
  desc: 'Send a message with specific content to the contacts, and you can send text or attachments.',
  primaryKey: (values: FieldValues): string => {
    if (values.content != null && values.content !== '') {
      return String(values.content);
    }

    const files = Array.isArray(values.files) ? values.files : [];
    if (files.length > 0) {
      const fileLabel = (f: unknown) =>
        f && typeof f === 'object' && 'name' in f ? String((f as { name?: string }).name) : 'Untitled File';
      return files.map(fileLabel).join(',');
    }

    return '';
  },

  // Form
  formFields: [
    {
      key: 'messageType',
      label: 'Message Type',
      type: 'select',
      defaultValue: 'text',
      options: [
        { label: 'Text', value: 'text' },
        { label: 'Attachment', value: 'attachment' },
      ],
      onChange: (value: FieldValue, allValues: FieldValues, allFields: Record<string, StepFormField>) => {
        if (value === 'attachment') {
          allFields.files.show = true;
          allValues.content = null;
        } else {
          allFields.files.show = false;
          allValues.files = [];
        }
      },
    },
    {
      key: 'content',
      label: 'Message',
      type: 'textarea',
      show: (parentValues: Record<string, any>) => {
        return parentValues.messageType !== 'attachment';
      },
      defaultValue: null,
      validation: {
        required: true,
        maxLength: 1600,
      },
    },
    {
      key: 'files',
      label: 'Attachment',
      type: 'upload',
      enableCannedFiles: true,
      accept: ['image/*', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt'],
      desc: 'Max file size: 5MB',
      multiple: false,
      show: (parentValues: Record<string, any>) => {
        return parentValues.messageType === 'attachment';
      },
      validation: {
        required: true,
      },
    },
  ],
};

export default sendMessage;
